import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'

import { queryClient } from '@/lib/queryClient'
import { SessionProvider } from '@/lib/session'
import { router } from '@/routes/router'

/**
 * Provider stack.
 *
 * SessionProvider sits inside QueryClientProvider (it is a query) and outside
 * the router (every route asks whether there is a session), so the session is
 * fetched exactly once per page load no matter how the app is entered.
 */
export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <RouterProvider router={router} />
      </SessionProvider>
    </QueryClientProvider>
  )
}
